import React from 'react';
import NumberInput, { Props as InputProps } from '../NumberInput';
import FormGroup, { Props as FormGroupProps } from '../FormGroup';

export type Props = Omit<FormGroupProps, 'children'> & InputProps;
export default function NumberInputGroup(props: Props) {
  const {
    error,
    label,
    labelInfo,
    id,
    autoFocus = false,
    className = '',
    large = false,
    placeholder,
    inputRef,
    extraLarge,
    onChange,
    onBlur,
    autoComplete,
    withoutMargin = false,
    value,
    ...rest
  } = props;
  return (
    <FormGroup
      id={id}
      error={error}
      label={label}
      labelInfo={labelInfo}
      withoutMargin={withoutMargin}
    >
      <NumberInput
        id={id}
        error={error}
        inputRef={inputRef}
        extraLarge={extraLarge}
        autoFocus={autoFocus}
        rightElement={props.rightElement}
        placeholder={placeholder}
        large={large}
        className={className}
        onChange={onChange}
        value={value}
        onBlur={onBlur}
        autoComplete={autoComplete}
        {...rest}
      />
    </FormGroup>
  );
}
